import a from './axios'
import config from '@/config'
const token = localStorage.getItem('token')
a.defaults.headers.common = { Authorization: `Bearer ${token}` }
const headers = {
  'Content-Type': 'application/json'
}

const prefixEndpoint = config.apiBaseUrl

export default {
  getList() {
    return a.post(prefixEndpoint + 'role/list', {}, headers)
  },
  addRole(payload) {
    return a.post(prefixEndpoint + 'role/add', payload, headers)
  },
  readRole(payload) {
    return a.post(prefixEndpoint + 'role', payload, headers)
  },
  editRole(payload) {
    return a.post(prefixEndpoint + 'role/update', payload, headers)
  },
  deleteRole(payload) {
    return a.post(prefixEndpoint + 'role/delete', payload, headers)
  }
}
